import { useState } from 'react'

import { ILanguage } from '@/types/task.interface'

import { uploadSrtShotlist } from '../actions/uploadSrtShotlist'

interface IUseFileSrtUploadParams {
	taskId?: string
	refetchShotlist: () => Promise<unknown>
	onCloseSrtDialog: () => void
}

export const useFileSrtUpload = ({
	taskId,
	refetchShotlist,
	onCloseSrtDialog
}: IUseFileSrtUploadParams) => {
	const [selectedSrtLang, setSelectedSrtLang] = useState<ILanguage | null>(null)
	const [selectedSrtFile, setSelectedSrtFile] = useState<File | null>(null)
	const [isSrtUploading, setIsSrtUploading] = useState(false)

	const onUploadSrtShotlist = async () => {
		if (isSrtUploading || !selectedSrtFile || !taskId || !selectedSrtLang)
			return
		onCloseSrtDialog()
		try {
			setIsSrtUploading(true)

			await uploadSrtShotlist({
				taskId,
				selectedSrtFile,
				selectedSrtLang
			})

			await refetchShotlist()
		} catch (error) {
			console.log(error)
		} finally {
			setIsSrtUploading(false)
		}
	}

	return {
		selectedSrtLang,
		setSelectedSrtLang,
		selectedSrtFile,
		setSelectedSrtFile,
		isSrtUploading,
		onUploadSrtShotlist
	}
}
